<template>
    <div class="benefit">
        <div class="icon mb-4"><img :src="`${icon}`" :alt="title" /></div>
        <p class="text-center text-md lg:text-xl font-medium">{{ title }}</p>
    </div>
</template>

<script setup>
defineProps({
    title: {
        type: String,
        default: ''
    },
    icon: {
        type: String,
        default: ''
    }
});
</script>

<style lang="scss" scoped>
.benefit {
    max-width: 25%;
    .icon {
        display: flex;
        justify-content: center;
    }
    @media (max-width: 767px),(min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) {
        max-width: 45%;
    }
}
</style>